<!-- The Modal -->
<div class="dialog__modal">
    <!-- Modal content -->
    <div class="dialog__content">
        <h1>Unsupported Browser</h1>
        <p>
            The browser you are using does not support the required cryptography
            APIs. Please use a more up to date browser.
        </p>
        <b>This dialog cannot be closed.</b>
    </div>
</div>
